module.exports = __webpack_public_path__ + "img/c41.c60fe138.png";